/**
 * @function Events
 */
function Events() {
  const options = new Map();

  this.setOption = (key, value) => {
    options.set(key, value);
  };

  this.getOption = value => {
    options.get(value);
  };

  this.init = () => {
    options.set(
      "output",
      document.getElementById(options.get("template").dataset.output)
    );
    options.set("search_string", options.get("template").dataset.filter);
    this.getEvents();
    this.filter();
  };

  this.update = search_string => {
    options.set("search_string", search_string);
    this.getEvents();
  };

  this.getEvents = (pageNum, perPage) => {
    pageNum = typeof pageNum === "undefined" ? "&paged=1" : "&paged=" + pageNum;
    perPage =
      typeof perPage === "undefined"
        ? "&posts-per-page=-1"
        : "&posts-per-page=" + pageNum;
    let request = new XMLHttpRequest();

    request.open(
      "GET",
      "/wp-json/90dl/v1/get_events/?q=" +
        options.get("search_string") +
        pageNum +
        perPage
    );
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        let response = request.responseText;
        this.render(response);
      } else {
        console.error(
          "Error Code: " + request.status + " - Please check the API"
        );
      }
    };
    request.onerror = () => {
      console.error("Failed to retrieve members from API");
    };
    request.send();
  };

  this.render = events => {
    if (typeof events === "undefined") {
      console.error("No data provided");
    } else {
      events = JSON.parse(events);
      options.set("events", events);
      let template = Handlebars.compile(options.get("template").innerHTML);
      options.get("output").classList.remove("active");
      let rendered = template(events);
      options.get("output").innerHTML = rendered;
      setTimeout(() => {
        options.get("output").classList.add("active");
        if (events.total === "") {
          let _noEvents = document.getElementsByClassName("no-events");
          _noEvents[0].classList.add("active");
        }
        if (events.paginate === true) {
          this.paginate();
        }
      }, 200);
      //Apologies
    }
  };

  this.paginate = () => {
    let pages = options.get("events")["posts_per_page"];
    var paginate_options = {
      page: 6,
      pagination: true
    };
    var listObj = new List(options.get("output")["id"], paginate_options);

    listObj.on("updated", () => {
      let eventTop = document.getElementById(options.get("output")["id"]);
      eventTop.scrollIntoView(true, { behaviour: "smooth" });
      window.scrollBy(0, -200);
    });
  };

  this.filter = state => {
    if (state) {
      this.update(state);
      const thisFilter = document.querySelectorAll(
        '[data-filter~="' + state + '"]'
      )[0];
      if (typeof thisFilter !== "undefined") {
        thisFilter.classList.add("active-filter");
      }
    }
    const event_filter = document.getElementsByClassName("event_filter");

    if (event_filter.length) {
      for (let i = 0; i < event_filter.length; i++) {
        let filter = event_filter[i];

        filter.addEventListener("click", e => {
          //clear previous active state
          for (let f = 0; f < event_filter.length; f++) {
            event_filter[f].classList.remove("active-filter");
          }
          filter.classList.add("active-filter");
          let filter_str = filter.dataset.filter;
          sessionStorage.setItem("eventsFilterState", filter_str);
          this.update(filter_str);
          e.preventDefault();
        });
      }
    }
  };
}

document.addEventListener("DOMContentLoaded", event => {
  const section_container = document.getElementsByClassName("type-events-list");
  const single_event_container = document.getElementsByClassName(
    "event-single"
  );

  //clear storage if other page
  if (!single_event_container.length && !section_container.length) {
    clearFilterState();
  } else {
    if (single_event_container.length) {
      //actions on single-event page
      sessionStorage.setItem("fromEvent", true);
    }
    //actions on events index page
    if (section_container.length) {
      //handle page reloading to clear filters in storage
      if (window.performance && performance.navigation.type == 1) {
        clearFilterState();
      }
      //check if we came from an event page
      const fromEvent = sessionStorage.getItem("fromEvent");
      const filterState = sessionStorage.getItem("eventsFilterState");
      const _EVENTS = [];
      const event_containers = document.getElementsByClassName("event-list");

      for (let i = 0; i < event_containers.length; i++) {
        let event_container = event_containers[i];
        let events = new Events();
        events.setOption("template", event_container);
        _EVENTS.push(events);
        events.init();

        if (fromEvent && filterState) {
          console.log("i came from an event page");
          console.log(filterState);
          console.log(document.referrer);
          setTimeout(() => {
            events.filter(filterState);
          }, 200);
        }
      }
    }
  }

  function clearFilterState() {
    sessionStorage.setItem("fromEvent", false);
    sessionStorage.setItem("eventsFilterState", "");
  }
});
